import React, { Component, forwardRef } from 'react';
import { Link, Redirect } from 'react-router-dom';
import MaterialTable from 'material-table';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Loader from '../../Loader.js';
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Button from '@material-ui/core/Button';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { LocalizationTheme } from '../../../utils/utils.js';
import { DisplayMessage } from '../../../services/helpers.js';
import FontDownloadRoundedIcon from '@material-ui/icons/FontDownloadRounded';
import { sortTableStringsNotCaseSensitive } from '../../../utils/tableSorting.js';
import appFetch from '../../../api/appFetch.js';
import { InternalChatGroupsUrl, InternalChatGroupsWithIdUrl } from '../../../constants/apiUrls.js';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    FontDownloadRoundedIcon: forwardRef((props, ref) => <FontDownloadRoundedIcon {...props} ref={ref} />)
};

export default class ChatGroupsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataGrid: [],
            outletId: 0,
            fetchingData: true,
            showDelete: false,
            showCopy: false,
            deletedItem: 0,
            copiedChatGroup: undefined,
            accessibleMoboOutlets: [],
            editedChatGroupId: undefined,
            editedChatGroup: undefined,
            showEditChatGroup: false,
            requestInProgress: false,
        };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.refreshGrid) {
            this.getData();
        }
        
        this.setState({ redirect: null });
    }

    componentDidMount() {
        this.getData();
    }

    handleChangeOutlet = e => {
        this.setState({ outletId: e.target.value, copiedOutletId: e.target.value }, () => this.getData(this.state.outletId));
    };

    handleChangeCopiedOutlet = e => {
        this.setState({ copiedOutletId: e.target.value });
    };

    getData = () => {
        this.setState({ fetchingData: true });
        let initialData = {};
        var resources = this.props.resources;
        initialData.columns = [
            { 
                title: resources["Description"],
                width: "45%",
                field: 'description',
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.description, b.description) 
            },
            { 
                title: resources["Outlet"],
                width: "25%",
                field: 'moboOutletDescription',
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.moboOutletDescription, b.moboOutletDescription) 
            },
            { 
                title: resources["IsActive"],
                field: 'isActive',
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.isActive, b.isActive) 
            },
        ];

        initialData.actions = [
            {
                icon: () => <Edit />,
                tooltip: resources["Edit"],
                onClick: (event, rowData) => this.setState({ redirect: `chatgroups/${rowData.id}`, editedChatGroupId: rowData.id, editedChatGroup: rowData })
            },
            {
                icon: () => <DeleteOutline />,
                tooltip: resources["Delete"],
                onClick: (event, rowData) => this.handleShowDelete(rowData.id)
            }
        ]

        appFetch({
            url: InternalChatGroupsUrl(),
            onSuccess: (data) => {
                const currentRows = [];

                data.sort((el1, el2) => el1.id - el2.id).forEach(function (rowData) {
                    currentRows.push({
                        id: rowData.id,
                        description: rowData.description,
                        chatName: rowData.internalDialogName,
                        isActive: rowData.isActive ? resources["Yes"] : resources["No"],
                        isActiveValue: rowData.isActive,
                        moboOutletDescription: rowData.moboOutletDescription !== null ? rowData.moboOutletDescription : "",
                        moboOutletID: rowData.moboOutletID,
                        usages: rowData.usages,
                        modifiedOn: rowData.modifiedOn,
                        modifiedByName: rowData.modifiedByName,
                        modifiedByAvatar: rowData.modifiedByAvatar,
                    });
                });

                initialData.data = currentRows;

                this.setState({
                    dataGrid: initialData,
                    fetchingData: false
                });
            },
            onError: (data) => {

            },
            onFinalize: () => {
                this.setState({ fetchingData: false });
            }
        })
    }

    handleCloseDelete = () => {
        this.setState({ showDelete: false, deletedItem: undefined });
    }

    handleEditChatGroup = (itemId, showEditChatGroupDialog) => {
        if (showEditChatGroupDialog === false) { 
            this.getData(this.state.outletId); 
        }

        this.setState({ showEditChatGroup: showEditChatGroupDialog, editedChatGroupId: itemId });
    }

    handleShowDelete = (itemId) => {
        this.setState({ showDelete: true, deletedItem: itemId });
    }

    handleDeleteChatGroup = () => {
        if (this.state.deletedItem > 0) {
            let resources = this.props.resources;
            this.setState({ requestInProgress: true });
            const url = InternalChatGroupsWithIdUrl(this.state.deletedItem)

            appFetch({
                url: url,
                method: 'DELETE',
                onSuccess: () => {
                    DisplayMessage(resources["ChatGroupWasDeleted"], "success");
                    this.getData(this.state.outletId);
                    this.setState({ showDelete: false, deletedItem: 0 });
                    this.handleCloseDelete();
                },
                onError: (data, response) => {
                    if (response.statusText.length > 0) {
                        DisplayMessage(response.statusText, "error");
                    }

                    for (var i = 0; i < data.errors.length; i++) {
                        DisplayMessage(data.errors[i], "error");
                    }
                },
                onFinalize: () => {
                    this.setState({ requestInProgress: false });
                }
            })
        }
    }

    renderOutlets = () => {
        var outlets = this.props.accessibleMoboOutlets.sort((a, b) => (a.description > b.description) ? 1 : -1)
        if (this.props.accessibleMoboOutlets === undefined) { 
            return; 
        }

        var outletOptions = outlets.map(x => <option key={x.id} value={x.id}> {x.description}</option>);
        return outletOptions;
    }


    render() {
        const { redirect, fetchingData } = this.state;
        const { resources } = this.props;

        if (redirect) {
            return (<Redirect to={{
                pathname: redirect,
                state: { outletId: this.state.outletId, editedChatGroupId: this.state.editedChatGroupId, editedChatGroup: this.state.editedChatGroup, refreshGrid: true }
            }}
            />)
        }

        return (
            <div>
                <div className="position-relative py-4">
                    <h3>{resources["ChatGroupsTitle"]}</h3>
                    <div className={"offcentered-loader " + (fetchingData ? 'fadeIn' : 'fadeOut')}><CircularProgress /></div>
                    <div className={"mt-4 " + (fetchingData ? 'fadeOut' : 'fadeIn')}>
                        <div style={{ float: "right", marginBottom: "10px" }}>
                            <Link to={{ pathname: "/chatgroups/new", state: { outletId: this.state.outletId } }} style={{ textDecoration: 'none' }}>
                                <Button id="add-ChatGroup" variant="contained" color="primary">
                                    <i className="fas fa-plus mr-2" title={resources["AddNewChatGroup"]} />
                                    {resources["AddNewChatGroup"]}
                                </Button>
                            </Link >
                        </div>
                        <div style={{ clear: "both", }}></div>

                        <Paper elevation={3} className="p-3 mt-3">
                            <MuiThemeProvider theme={LocalizationTheme()}>
                                <MaterialTable
                                    icons={tableIcons}
                                    title={""}
                                    localization={{
                                        header: { actions: resources["Actions"] },
                                        body: {
                                            emptyDataSourceMessage: resources["NoRecordsToBeDisplayed"],
                                            deleteTooltip: resources["DeleteTooltip"],
                                            editTooltip: resources["EditTooltip"],
                                        },
                                        toolbar: {
                                            searchPlaceholder: resources["Search"],
                                            searchTooltip: resources["Search"]
                                        },
                                        pagination: {
                                            firstTooltip: resources["FirstTooltip"],
                                            lastTooltip: resources["LastTooltip"],

                                            previousTooltip: resources["PreviousTooltip"],
                                            nextTooltip: resources["NextTooltip"],

                                            labelRowsPerPage: resources["LabelRowsPerPage"],
                                            labelRowsSelect: resources["LabelRowsSelect"],
                                        }
                                    }}
                                    data={this.state.dataGrid.data}
                                    columns={this.state.dataGrid.columns}
                                    actions={this.state.dataGrid.actions}
                                    options={{ emptyRowsWhenPaging: false, pageSize: 10, pageSizeOptions: [10, 15, 20] }}
                                />
                            </MuiThemeProvider>
                        </Paper>
                    </div>
                    <div className={"loader-overlap position-absolute " + (this.state.fetchingData ? 'fadeIn' : 'fadeOut')}><div className="container"><Loader /></div></div>

                    <Rodal visible={this.state.showDelete} onClose={this.handleCloseDelete} className="rodal" customStyles={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
                    }}>
                        <div className="modal-body" style={{ marginTop: "20px", display: "flex", alignItems: "center" }}>{resources["AreYouSureYouWantToDeleteChatGroup"]}</div>
                        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                            <button className="btn btn-secondary" id="btnCancelDelete" style={{ backgroundColor: "white", color: "#53B3EA", borderColor: "#53B3EA" }}
                                onClick={this.handleCloseDelete} disabled={this.state.requestInProgress}>{resources["Cancel"]}</button>
                            <button className="btn btn-primary" id="btnDelete" style={{ backgroundColor: "#53B3EA", color: "white", borderColor: "#53B3EA" }}
                                onClick={this.handleDeleteChatGroup} disabled={this.state.requestInProgress}>{resources["Yes"]}</button>
                        </div>
                        <span className="rodal-close"></span>
                    </Rodal>
                </div>
            </div >
        )
    };
}